import { render, staticRenderFns } from "./ParticipationViewContentContainer.vue?vue&type=template&id=2c0ef5f3&scoped=true&"
import script from "./ParticipationViewContentContainer.vue?vue&type=script&lang=js&"
export * from "./ParticipationViewContentContainer.vue?vue&type=script&lang=js&"
import style0 from "./ParticipationViewContentContainer.vue?vue&type=style&index=0&id=2c0ef5f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0ef5f3",
  null
  
)

export default component.exports